export default __webpack_public_path__ + "static/arc-73974b25e495dbb67cf9353ea5541b18.png";